'use client';

import React from 'react';
import { Box } from '@chakra-ui/react';
import { IProps } from './_types';
import Mobile from './header.mobile';
import Desktop from './header.desktop';

import { useTelegramBackButton } from '../../_hooks/useTelegramBackButton';

const UniversalHeader = ({
  onBack,
  onClick,
  icon,
  backLink,
  fullTitle = false,
  title = '',
  isBackIcon,
  subtitle,
}: IProps) => {
  const { isVisible } = useTelegramBackButton({ onBack });

  const sharedProps = {
    icon,
    fullTitle,
    title,
    onBack,
    onClick,
    backLink,
    subtitle,
  };

  return (
    <>
      <Box display={{ base: 'none', lg: 'block' }}>
        <Desktop {...sharedProps} />
      </Box>
      <Box display={{ base: 'block', lg: 'none' }}>
        <Mobile
          {...sharedProps}
          isBackIcon={isBackIcon && !isVisible}
        />
      </Box>
    </>
  );
};

export default UniversalHeader;
